<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create Cluster'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            class="mb-4"
        />
        <input-text
            name="workspace_slug"
            label="Workspace (Organisation) Slug"
            v-model="form.workspace_slug"
            :error="errors.workspace_slug ? errors.workspace_slug[0] : null"
            class="mb-4"
        />
        <input-text
            name="repository_slug"
            label="FE Repository Slug"
            v-model="form.repository_slug"
            :error="errors.repository_slug ? errors.repository_slug[0] : null"
        />
        <input type="hidden" name="_token" :value="csrf"/>
        <input v-if="data" type="hidden" name="_method" value="patch"/>
    </form>
</template>

<script>
import crudForm from '../mixins/crudForm'

export default {
    name: "ClusterForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                name: this.getFormData('name'),
                workspace_slug: this.getFormData('workspace_slug'),
                repository_slug: this.getFormData('repository_slug'),
            },
        }
    },
}
</script>
